class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.loadMoreItems.bind(this));
    this.currentPage = 1;
  }

  loadMoreItems() {
    const loadMoreBtn = this.querySelector('[type="button"]');
    if (loadMoreBtn.hasAttribute("disabled")) return;
    
    loadMoreBtn.setAttribute("disabled", true);
    
    const { pageSize, nextUrl, totalItems, totalPages } = this.dataset;
    console.log(this.dataset);
    const nextPage = this.currentPage + 1;
    
    fetch(nextUrl.replace(/page=[0-9]+/, `page=${nextPage}`))
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
      })
      .then(responseText => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');
        const newProducts = doc.querySelector('#product-grid');
        const newNextUrl = doc.querySelector('load-more')?.dataset?.nextUrl;
        
        if (newProducts) {
          document.querySelector('#product-grid').insertAdjacentHTML('beforeend', newProducts.innerHTML);
          this.currentPage = nextPage;
          this.dataset.currentPage = nextPage.toString();
          
          // Update nextUrl from response for next request
          if (newNextUrl) {
            this.dataset.nextUrl = newNextUrl;
          }
          
          const itemsShown = Math.min(nextPage * parseInt(pageSize), parseInt(totalItems));
          this.querySelector("[load-items-count]").textContent = itemsShown.toString();
          
          const isLastPage = nextPage >= parseInt(totalPages);
          if (isLastPage) {
            loadMoreBtn.setAttribute("disabled", true);
            loadMoreBtn.style.display = 'none';
          } else {
            loadMoreBtn.removeAttribute("disabled");
          }
        }
      })
      .catch(error => {
        console.error('Error loading more items:', error);
        alert('Failed to load more items. Please try again.');
      })
      .finally(() => {
        if (!loadMoreBtn.style.display === 'none') {
          loadMoreBtn.removeAttribute("disabled");
        }
      });
  }
}

customElements.define("load-more", LoadMore);
